<template>
  <div style="height: 400px" v-if="isMapLoading">
    <loading-progress
      :progress="60"
      :indeterminate=true
      :hide-background="true"
      size="64"
      rotate
      fillDuration="2"
      rotationDuration="1"
      class="d-inline"
    />
  </div>
  <div style="width: 100%; height: 100%" class="light" v-else>
    <div v-if="!isEmpty" style="width: 100%; height: 100%">
      <GmapMap ref="mapRef"
        :center="center"
        :zoom="defaultZoom"
        map-type-id="terrain"
        style="width: 100%; height: 100%"
      >
        <GmapMarker
          v-if="markers && markers.length > 0"
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m,index)"
        />
        <GmapMarker
          v-if="drops && drops.length > 0"
          :key="m.index"
          v-for="m in drops"
          :position="m.position"
          :clickable="true"
          @click="toggleInfoWindow(m, m.index)"
        />
        <GmapPolyline v-if="paths && paths.length > 0" :path="paths"
            ref="polyline">
        </GmapPolyline>
        <GmapInfoWindow :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false">
          <span v-html="infoContent"></span>
        </GmapInfoWindow>
      </GmapMap>
    </div>
    <div v-else>
      <span class="no-location-text">Location Not Available</span>
    </div>
  </div>
</template>

<script>
import TruckIcon from '@common/asset/images/truck.svg';

export default {
  props: {
    data: {
      type: Object,
    },
  },

  data() {
    const mapData = this.$session.get('mapData');
    const paths = mapData && mapData.locations && mapData.locations.length ? mapData.locations.map((path) => {
      const position = { lat: path.loc[0], lng: path.loc[1], createdAt: path.createdAt };
      return position;
    }) : null;
    const drops = mapData && mapData.trip && mapData.trip.drops.length ? mapData.trip.drops.map((drop, index) => {
      const position = { lat: drop.loc[0], lng: drop.loc[1] };
      return {
        index: paths && paths.length + index,
        position,
        type: 'drop',
        name: drop.name,
      };
    }) : null;
    const location = paths && paths.length > 0 ? paths[0] : null;
    return {
      center: paths && paths.length && paths[0],
      isEmpty: (!location) || (!drops),
      markers: [{
        position: location,
        icon: `${TruckIcon}`,
        curr_ETA: mapData.trip ? mapData.trip.curr_ETA : null,
        truck_number: mapData.trip ? mapData.trip.truck_number : null,
      }],
      places: [],
      drops,
      paths,
      currentPlace: null,
      isMapLoading: false,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -25,
        },
      },
      currentMidx: null,
      defaultZoom: mapData && mapData.mapSettings && mapData.mapSettings.gmap_zoom,
    };
  },

  methods: {
    dateFormat(date) {
      return `${date.toDateString()} ${date.toLocaleTimeString()}`;
    },

    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      if (marker.type === 'drop') {
        this.infoContent = marker.name;
      } else {
        const currentETA = marker.curr_ETA ? this.dateFormat(new Date(marker.curr_ETA)) : '-';
        const lastSeen = new Date(marker.position.createdAt);
        this.infoContent = `<b>Truck no:</b> ${marker.truck_number} <br/> <b>ETA:</b> ${currentETA} <br/>  <b>Last seen:</b> ${this.dateFormat(lastSeen)}`;
      }

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.center = marker.position;
    },
  },
};
</script>
<style lang="scss">
.no-location-text {
  color: #6D8EB4;
  display: inline-block;
  margin-left: 20px;
  font-size: 18px;
  font-weight: 300;
}
.light {
  .gm-style .gm-style-iw-c {
    background-color: white !important;
  }
}
</style>
